import KeyboardDoubleArrowDownRoundedIcon from "@mui/icons-material/KeyboardDoubleArrowDownRounded";

const ScrollDownIndicator = () => {
    return <div className='scroll-down-indicator'>
        <KeyboardDoubleArrowDownRoundedIcon fontSize='large'/>
    </div>
}

export default ScrollDownIndicator